export const getOrderPaymentsByLocationServiceURL = queryString =>
  `${process.env.REACT_APP_HOST}/api/data-service/order-payments/by-location?${queryString}`
